<div class="modal-body change-user-password-popup">
  <div class="content">
    <div class="top">
      <h4 *ngIf="user.enabled" translate>company.user.password-popup.title-set</h4>
      <h4 *ngIf="!user.enabled" translate>company.user.password-popup.title-activate</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <gdp-user-password-form
      [submitLabel]="
      user.enabled
      ? 'company.user.password-popup.button-update'
      : 'company.user.password-popup.button-activate'
      "
      [loading]="loading"
      (onSubmit)="submit($event)">
    </gdp-user-password-form>
  </div>
</div>
